export default function checkMobile(userAgent) {
  return /Android|webOS|iPhone|iPod|BlackBerry|atzuche/i.test(userAgent)
}
